export default "__VITE_ASSET__E0Gj2I9Z__"